<template>
  <div>
    <v-sheet class="py-4 px-1">
      <v-chip-group center-active show-arrows>
        <v-chip
          v-for="(item, i) in subCategories"
          :key="i"
          :color="$route.query.subcategory == item._id ? '#EC2300' : '#1D1C1C'"
          @click="changeRoute(item)"
        >
          <span
            style="
              font-family: poppinssemibold;
              font-size: 12px;
              color: #ffffff;
              letter-spacing: 2px;
            "
          >
            {{ item.name }}
          </span>
        </v-chip>
      </v-chip-group>
    </v-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
    };
  },
  beforeMount() {
    this.$store.dispatch("getSubCategory");
  },
   computed: {
    subCategories() {
      return this.$store.state.subCategories;
    },
  },
  methods: {
    changeRoute(item) {
      this.$router.push({
        path: "/Products",
        query: {
          styl: this.$route.query.styl,
          category: this.$route.query.category,
          subcategory:
            this.$route.query.subcategory != item._id ? item._id : null,
          searchKey: this.$route.query.searchKey,
          type: this.$route.query.type,
        },
      });
    },
  },
};
</script>